/**
 * Whether an equipment-reference field holds no selection. Absent and null
 * mean the field was never set; the empty string is how a cleared selection
 * is stored, and how an agent leaves a field unset when the cell has no
 * equipment of the kind. None of the three name equipment, so none may reach
 * an equipment exists-check: an unset field reports as "must set" (where the
 * step requires one), never as equipment that was removed from the robot.
 */
export function isUnsetEquipmentRef(
  value: string | null | undefined,
): value is null | undefined | '' {
  return value == null || value === '';
}
